{
  "root": {
    "error": {
      "title": "This page could not be loaded"
    },
    "backToCanvases": "Back to my canvases",
    "notFound": {
      "title": "Page not found",
      "message": "This URL does not match anything in the app."
    }
  },
  "app": {
    "openMenu": "Open menu",
    "menu": "Menu"
  },
  "inbox": {
    "title": "Inbox",
    "subtitle": "Everything Nolë did that you haven't looked at yet, across all your canvases."
  },
  "tutorials": {
    "title": "Tutorials",
    "subtitle": "Short guides to get the most out of your canvases and Nolë.",
    "comingSoon": "Coming soon",
    "featured": {
      "badge": "Start here",
      "title": "Nolënor in two minutes",
      "description": "Create a canvas, drop in a few documents, and ask Nolë to work through them with you."
    },
    "items": {
      "firstCanvas": {
        "title": "Your first canvas",
        "description": "Add documents, notes and links, then arrange them your way."
      },
      "withNole": {
        "title": "Working with Nolë",
        "description": "Attach blocks, give instructions, review what it changed."
      },
      "tablesApps": {
        "title": "Tables and apps",
        "description": "Structured data and small tools that live on the canvas."
      },
      "connectAssistants": {
        "title": "Connect Claude or ChatGPT",
        "description": "Use your canvases from other assistants through MCP."
      },
      "capture": {
        "title": "Capture on the go",
        "description": "Voice notes, photos and links from your phone."
      },
      "shortcuts": {
        "title": "Keyboard shortcuts",
        "description": "Move around and create blocks without the mouse."
      }
    }
  },
  "canvasRoute": {
    "loadError": "This canvas could not be loaded"
  },
  "signin": {
    "toasts": {
      "googleFailed": "Could not start Google sign-in. Please try again.",
      "verificationSent": "We sent a verification code to your email.",
      "loggedIn": "Successfully logged in!",
      "accountCreated": "Account created successfully!",
      "emailVerified": "Email verified!",
      "resetSent": "We sent a reset code to your email.",
      "passwordUpdated": "Password updated!"
    },
    "errors": {
      "accountExists": "This account already exists. Log in or use a different email.",
      "passwordTooShort": "Password must be at least 8 characters.",
      "incorrectPassword": "Incorrect password.",
      "noAccount": "No account found with this email.",
      "invalidEmail": "Invalid email.",
      "loginFailed": "Unable to log in. Please try again.",
      "invalidCode": "Invalid or expired code.",
      "noPasswordAccount": "No password sign-in for this email. If you signed up with Google, use Continue with Google.",
      "resetFailed": "Could not send the reset code. Please try again."
    },
    "headings": {
      "newPassword": "Choose a new password",
      "checkEmail": "Check your email",
      "resetPassword": "Reset your password",
      "welcomeBack": "Welcome back",
      "createAccount": "Create an account"
    },
    "subtitles": {
      "codeSent": "We sent a code to <email>{{email}}</email>",
      "forgot": "We'll email you a code to choose a new password",
      "signIn": "Log in to your account to continue",
      "signUp": "Get started for free"
    },
    "fields": {
      "newPassword": "New password",
      "password": "Password",
      "emailPlaceholder": "name@example.com"
    },
    "actions": {
      "updatePassword": "Update password",
      "sendCode": "Send code",
      "google": "Continue with Google",
      "forgotPassword": "Forgot password?",
      "logIn": "Log in",
      "createAccount": "Create account",
      "backToLogIn": "Back to log in"
    },
    "or": "or",
    "switch": {
      "noAccount": "Don't have an account?",
      "hasAccount": "Already have an account?"
    }
  },
  "newCanvas": "New canvas",
  "sidebar": {
    "mainNav": "Main",
    "nav": {
      "home": "Home",
      "inbox": "Inbox",
      "tutorials": "Tutorials"
    },
    "aiUsage": {
      "title": "AI usage",
      "period": "Last 30 days"
    },
    "account": {
      "fallbackName": "Your account",
      "signOut": "Sign out"
    }
  },
  "home": {
    "welcome": {
      "title": "Welcome to Nolënor",
      "description": "A canvas is an infinite board. Drop in documents, images, audio, links and notes, connect them together, and ask Nolë — the assistant that reads everything on the canvas — to work through it with you.",
      "cta": "Create your first canvas"
    },
    "greeting": {
      "morning": "Good morning",
      "afternoon": "Good afternoon",
      "evening": "Good evening",
      "morningWithName": "Good morning, {{name}}",
      "afternoonWithName": "Good afternoon, {{name}}",
      "eveningWithName": "Good evening, {{name}}"
    },
    "subtitle": {
      "tasks_one": "{{count}} task needs your attention.",
      "tasks_other": "{{count}} tasks need your attention.",
      "firstCanvas": "Let's set up your first canvas.",
      "caughtUp": "You're all caught up."
    },
    "workspace": {
      "openCanvas": "Open {{name}}",
      "shared": "Shared",
      "yours": "Yours",
      "actionsFor": "Actions for {{name}}",
      "tasks_one": "{{count}} task",
      "tasks_other": "{{count}} tasks"
    },
    "task": {
      "working": "Nolë is working on it…",
      "inThread": "In “{{title}}”",
      "timeSpent": "Time spent",
      "blocksTouched": "Blocks touched",
      "stillRunning": "Still running",
      "waiting": "Waiting for your answer",
      "markReviewed": "Mark as reviewed",
      "stillRunningAria": "{{title}} is still running",
      "waitingAria": "{{title}} is waiting for your answer",
      "markReviewedAria": "Mark {{title}} as reviewed"
    },
    "tasks": {
      "title": "Needs your attention",
      "clearAll": "Clear all finished",
      "empty": {
        "title": "You're all caught up",
        "description": "When Nolë finishes something, it lands here until you've looked at it."
      },
      "undoAria": "Undo clear of {{title}}",
      "viewAll_one": "View {{count}} in Inbox",
      "viewAll_other": "View all {{count}} in Inbox"
    },
    "recent": {
      "title": "Recent canvases",
      "filterLabel": "Filter canvases",
      "filters": {
        "all": "All",
        "mine": "Mine",
        "shared": "Shared with me"
      },
      "layoutLabel": "Layout",
      "gridView": "Grid view",
      "listView": "List view"
    }
  },
  "loading": {
    "then": "then",
    "gestures": {
      "click": "Click",
      "rightClick": "Right-click",
      "doubleClick": "Double-click",
      "drag": "Drag"
    },
    "tips": {
      "altClickBlock": "[Alt] + {click} a block → attach to Nolë",
      "altClickCanvas": "[Alt] + {click} empty canvas → point Nolë there",
      "shiftDrag": "[Shift] + {drag} → alignment guides",
      "modDrag": "[Mod] + {drag} a block → linked blocks follow",
      "appearance": "{right-click} → Appearance → switch variant",
      "compactFrame": "{right-click} a frame → Compact → more room",
      "mention": "{click} a mention → go · [Mod] + {click} → open",
      "scaleTitle": "{right-click} a title → Scale with zoom",
      "lasso": "[Mod] + lasso → skip frames",
      "alignSelection": "{right-click} a selection → align · tidy up",
      "dragConnection": "{drag} a connection to empty canvas → new block",
      "dropBlock": "[T] [D] [I] [A] [L] → drop a block at the pointer",
      "search": "[Mod] [K] → search everything, even PDFs",
      "jump": "[Mod] [P] → jump to a canvas or bookmark",
      "bookmark": "{right-click} canvas → Bookmark here · [B] → list",
      "frame": "[F] → draw a frame",
      "pan": "[Space] + {drag} → pan",
      "editLabel": "{double-click} a connection → edit its label",
      "snapWindow": "{drag} a window to a screen edge → snap",
      "dictate": "Hold [Ctrl] [Alt] in chat → dictate"
    }
  },
  "appError": {
    "message": "The app hit an unexpected error. Reloading usually fixes it — your work is saved on the server."
  },
  "errorDisplay": {
    "fallbackTitle": "Error",
    "fallbackMessage": "An error occurred"
  },
  "update": {
    "title": "✨ Nolënor just got an update",
    "messageAuto": "A new version was released while you were working. It's downloading now and the page will refresh by itself in a few seconds — your work is saved.",
    "messageManual": "A new version was released while you were working. Reload the page to start using it — your work is saved.",
    "downloading": "Downloading the new version…",
    "refreshing": "Refreshing…",
    "reloadToUpdate": "Reload to update",
    "checking": "Checking for updates…",
    "reloadPage": "Reload the page",
    "toast": "✨ Nolënor just got a new version."
  },
  "colors": {
    "red": "Red",
    "orange": "Orange",
    "yellow": "Yellow",
    "lime": "Lime",
    "green": "Green",
    "teal": "Teal",
    "sky": "Sky",
    "blue": "Blue",
    "purple": "Purple",
    "pink": "Pink",
    "grey": "Grey",
    "white": "White",
    "default": "Default",
    "transparent": "Transparent"
  },
  "layout": {
    "redo": "Redo",
    "layers": "Layers",
    "dialog": {
      "description": "Arrange rows, columns and their content. Nothing changes until you apply.",
      "unsaved": "Unsaved changes. The board updates when you apply.",
      "pristine": "Nothing changes until you apply."
    },
    "discard": {
      "title": "Discard layout changes?",
      "description": "Closing now will lose the changes you have not applied.",
      "keepEditing": "Keep editing",
      "confirm": "Discard changes"
    },
    "align": {
      "top": "Top",
      "left": "Left",
      "middle": "Middle",
      "center": "Center",
      "bottom": "Bottom",
      "right": "Right",
      "fill": "Fill",
      "spread": "Spread"
    },
    "row": "Row",
    "column": "Column",
    "rowRoot": "Row (root)",
    "columnRoot": "Column (root)",
    "between": "Between {{min}} and {{max}}",
    "elements_one": "{{count}} element",
    "elements_other": "{{count}} elements",
    "direction": "Direction",
    "alignItems": "Align items",
    "distribute": "Distribute",
    "gap": "Gap (px)",
    "padding": "Padding (px)",
    "addInside": "Add inside",
    "addAfter": "Add after",
    "wrapRow": "Wrap in a row",
    "wrapColumn": "Wrap in a column",
    "refusal": {
      "tooManyChildren": "A row or column holds {{max}} elements at most. Group some in a row or column first.",
      "tooDeep": "Rows and columns nest {{max}} levels deep at most. Select a shallower spot first."
    }
  }
}
